module.exports = __webpack_public_path__ + "img/logo_gold_lock.cdf0dea4.jpeg";